module.exports = __webpack_public_path__ + "img/x.86821729.png";